<template>
  <b-tr
    v-if="(filter.showErrorsOnly && item.hasError) || !filter.showErrorsOnly"
    :class="{ 'error-row': filter.showErrorsOnly }"
  >
    <b-td>
      <span class="text-capitalize">
        <BaseIcon
          v-if="item.hasError"
          name="circle"
          :class="{ error: item.hasError }"
        />
        {{ item.displayName }}
      </span>
      <template v-if="item.hasError && item.ruleText !== null">
        <BaseIcon :id="`bi_${itemId}`" name="info-circle" />
        <b-tooltip :target="`bi_${itemId}`" triggers="hover">
          {{ item.ruleText }}
        </b-tooltip>
      </template>
      <!-- Rate Spread  -->
      <template v-if="isRateSpreadAttribute(item.name)">
        <BaseEButton
          class="rateBtnPosition mt-2 pt-0"
          dense
          :disabled="false"
          @click="customLoanMethods('ratespread')"
        >
          Calculate Rate Spread
        </BaseEButton>
      </template>

      <!-- Geo code  -->
      <template v-if="isGeoCodeAttribute(item.name)">
        <BaseEButton
          class="rateBtnPosition mt-2 pt-0"
          dense
          :disabled="false"
          @click="customLoanMethods('geocode')"
        >
          Get Geo Code
        </BaseEButton>
      </template>
    </b-td>
    <b-td>
      <BaseEInputText
        v-if="!itemsWithSign.includes(itemId)"
        :value="item.currentValue"
        type="text"
        readonly
        size="sm"
        :class="{
          boxHighlighted: item.hasComments,
        }"
      />
       <BaseEInputText
        v-else
        :value="`$${item.currentValue}`"
        type="text"
        readonly
        size="sm"
        :class="{
          boxHighlighted: item.hasComments,
        }"
      />
    </b-td>
    <b-td>
      <div>
        <BaseEInputText
          v-model="item.newValue"
          type="text"
          size="sm"
          class="loanAttr"
          :placeholder="item.inputSuggestion ? item.inputSuggestion : ''"
          @blur="onBlurNewValue"
        />
      </div>
    </b-td>
    <b-td>
      <BaseEInputText
        v-model="item.comment"
        type="text"
        size="sm"
        :is-disabled="!isValueChanged"
        :class="boxRequiredClass"
      />
    </b-td>
    <b-td>
      <BaseEButton
        icon="comment-dots"
        variant="icon"
        :disabled="!item.hasComments"
        :class="!item.hasComments ? 'disabledComments' : ''"
        @click="onClickShowComment"
      />
    </b-td>
  </b-tr>
</template>

<script>
export default {
  props: {
    value: { type: Boolean },
    item: { type: Object, default: () => {} },
    filter: { type: Object, default: () => {} },
    commentsMandatory : { type: Boolean, default: false}
  },
  data() {
    return {
      itemId: this.item.dataAttributeId,
      itemsWithSign : [9, 56, 87]
    }
  },
  computed: {
    // to auto compute validity and state, keep it in computed
    isValueChanged() {
      let isChanged = (this.item.newValue || '').trim().length > 0
      let isValid = isChanged ? this.isCommentValid : true
      this.$emit('input', isChanged)
      this.$emit('state-updated', { item: this.item, isValid })
      return isChanged
    },
    isCommentValid() {
      return this.item.comment.length > 0
    },
    boxRequiredClass() {
      return this.isValueChanged && this.commentsMandatory // condition variable to be added here for comments mandate..
        ? this.isCommentValid
          ? 'boxRequiredGood'
          : 'boxRequired'
        : ''
    },
  },
  methods: {
    onClickShowComment() {
      this.$emit('onClickShowComment', this.item)
    },
    onBlurNewValue() {
      if (!this.isValueChanged) {
        this.item.comment = ''
      }
    },
    isRateSpreadAttribute(attribute) {
      return attribute ? attribute === 'RateSpread' : false
    },

    isGeoCodeAttribute(attribute) {
      return attribute ? attribute === 'CensusTract' : false
    },
    customLoanMethods(type) {
      this.$emit('onClickCustomLoanMethods', type)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@design';
table > tbody > tr.error-row > td {
  color: rgb(243, 13, 13) !important;
  font-weight: bold;
  /* background: rgb(237, 234, 234); */
}
table > tbody > tr > td {
  white-space: normal !important;
}
.td-w1 {
  min-width: 230px;
}
.td-w2 {
  min-width: 300px;
}
::v-deep .disabledComments > svg {
  color: $color-bg-lightGrey;
}
::v-deep .boxRequired > input {
  border: 1px solid red !important;
}
::v-deep .boxRequiredGood > input {
  border: 1px solid green !important;
}
::v-deep .boxHighlighted > input {
  border: 1px solid black !important;
}
.rateBtnPosition {
  margin-left: 20% !important;
}
</style>
